import React from 'react';
import { Props } from '../InlineView';
import TierPromotionCardSemiDumb from '../../../DeviationViews/TierPromotionCardEditorDumb';

import s from './Tier.scss';

const TierInlineView: React.FC<Props> = props => {
  const { deviation, width, height } = props;

  return (
    <div className={s['root']} style={{ width }}>
      <TierPromotionCardSemiDumb
        width={width}
        height={height}
        deviation={deviation}
        ctaButton="subscribe"
      />
    </div>
  );
};
TierInlineView.displayName = 'TierInlineView';

export default TierInlineView;
